module.exports = __webpack_public_path__ + "img/差评反馈图片.15720950.png";